import { call, put, takeLatest } from "redux-saga/effects";
import {
  barClubAddFailure,
  barClubAddSuccess,
  barClubDeleteFailure,
  barClubDeleteSuccess,
  barClubEditFailure,
  barClubEditSuccess,
  barClubViewAllByWholesalerIdFailure,
  barClubViewAllByWholesalerIdSuccess,
  barClubViewAllFailure,
  barClubViewAllSuccess,
  barClubViewFailure,
  barClubViewSearchByWholesalerIdViewAllFailure,
  barClubViewSearchByWholesalerIdViewAllSuccess,
  barClubViewSearchViewAllFailure,
  barClubViewSearchViewAllSuccess,
  barClubViewSuccess,
} from "./BarClubAction";
import {
  AddBarClubEffect,
  DeleteBarClubEffect,
  EditBarClubEffect,
  ViewAllBarClubByWholesalerIdEffect,
  ViewAllBarClubEffect,
  ViewAllSearchBarClubByWholesalerIdEffect,
  ViewAllSearchBarClubEffect,
  ViewBarClubEffect,
} from "./BarClubEffect";
import {
  BARCLUB_ADD_REQUEST,
  BARCLUB_DELETE_REQUEST,
  BARCLUB_EDIT_REQUEST,
  BARCLUB_SEARCH_REQUEST,
  BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST,
  BARCLUB_VIEW_ALL_REQUEST,
  BARCLUB_VIEW_REQUEST,
  BARCLUB_WHOLESALERID_SEARCH_REQUEST,
} from "./BarClubTypes";
// Add bar/club
function* addBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(AddBarClubEffect, action.payload, config);
    yield put(barClubAddSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to add bar/club";
    yield put(
      barClubAddFailure({
        errormessage: message,
        errorFields,
      })
    );
  }
}
// Edit bar/club
function* editBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const { id: barClubId, credentials: updates } = action.payload;
    const response = yield call(EditBarClubEffect, barClubId, updates, config);

    yield put(barClubEditSuccess(response.data));
  } catch (error) {
    const errorFields = error.response?.data?.errorFields || {};
    const message = error.response?.data?.message || "Failed to edit bar/club";
    yield put(barClubEditFailure({ errormessage: message, errorFields }));
  }
}
// View bar/club
function* viewBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewBarClubEffect, action.payload, config);
    yield put(barClubViewSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to view bar/club";
    yield put(barClubViewFailure({ errormessage: errorMessage }));
  }
}
// View all bars/clubs
function* viewAllBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(ViewAllBarClubEffect, action.payload, config);
    yield put(barClubViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to view all bars/clubs";
    yield put(barClubViewAllFailure({ errormessage: errorMessage }));
  }
}

// View all Search bars/clubs
function* viewAllSearchBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllSearchBarClubEffect,
      action.payload,
      config
    );
    yield put(barClubViewSearchViewAllSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(barClubViewSearchViewAllFailure({ errormessage: errorMessage }));
  }
}

// View all By Wholesaler Id bars/clubs
function* viewAllBarClubByWholesalerIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const { wholesalerId, pageNo,search_key } = action.payload;
    const response = yield call(
      ViewAllBarClubByWholesalerIdEffect,
      wholesalerId,
      pageNo,
      search_key,
      config
    );
    yield put(barClubViewAllByWholesalerIdSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to view all bars/clubs";
    yield put(
      barClubViewAllByWholesalerIdFailure({ errormessage: errorMessage })
    );
  }
}

// View all Search By Wholesaler Id bars/clubs
function* viewAllSearchBarClubByWholesalerIdSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(
      ViewAllSearchBarClubByWholesalerIdEffect,
      action.payload,
      config
    );
    yield put(barClubViewSearchByWholesalerIdViewAllSuccess(response?.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to fetch brands";
    yield put(
      barClubViewSearchByWholesalerIdViewAllFailure({
        errormessage: errorMessage,
      })
    );
  }
}

// Delete bar/club
function* deleteBarClubSaga(action) {
  try {
    const token = localStorage.getItem("accessToken");
    const config = token
      ? { headers: { Authorization: `Bearer ${token}` } }
      : {};
    const response = yield call(DeleteBarClubEffect, action.payload, config);
    yield put(barClubDeleteSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || "Failed to delete bar/club";
    yield put(barClubDeleteFailure({ errormessage: errorMessage }));
  }
}
export function* BarClubSaga() {
  yield takeLatest(BARCLUB_ADD_REQUEST, addBarClubSaga);
  yield takeLatest(BARCLUB_EDIT_REQUEST, editBarClubSaga);
  yield takeLatest(BARCLUB_VIEW_REQUEST, viewBarClubSaga);
  yield takeLatest(BARCLUB_VIEW_ALL_REQUEST, viewAllBarClubSaga);
  yield takeLatest(BARCLUB_DELETE_REQUEST, deleteBarClubSaga);
  yield takeLatest(BARCLUB_SEARCH_REQUEST, viewAllSearchBarClubSaga);
  yield takeLatest(
    BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST,
    viewAllBarClubByWholesalerIdSaga
  );
  yield takeLatest(
    BARCLUB_WHOLESALERID_SEARCH_REQUEST,
    viewAllSearchBarClubByWholesalerIdSaga
  );
}
